import { useCheckSectionPracticeResult, useCheckInstantResult } from "../../services/index"
import Loading from "../layout/Loading";
import { useEffect } from "react";
import { useExam } from "../../context/ExamContext";
import { FaCheckCircle, FaChartBar, FaArrowRight } from "react-icons/fa";
import { useExamServerDataOperations } from "../../hooks/useExamServerDataOperations"
import { useFinishSession } from "../../services/index"
import Feedback from "../feedback";

const PracticeExamFinished = ({ examId, userId }) => {
  const { uprId, examType, productType } = useExam();
  const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
  const triggerServerDataUpdate = useExamServerDataOperations();


  const {
    triggerFinishSession,
    isLoadingFinishSession,
    errorFinishSession,
  } = useFinishSession();

  const {
    triggerCheckSectionResult,
    data,
    isLoadingCheckResult,
    errorCheckResult
  } = useCheckSectionPracticeResult(productType, uprId);


  const {
    triggerCheckInstantResult,
    data: practiceResultData,
    isLoadingCheckPracticeResult,
    errorCheckPracticeResult
  } = useCheckInstantResult(uprId);


  useEffect(() => {
    if (!uprId) return;
    triggerServerDataUpdate()
    triggerFinishSession()
    if (productType === "reading" || productType === "listening") {
      triggerCheckSectionResult();
    } else {
      triggerCheckInstantResult();
    }
  }, [productType, uprId, triggerCheckSectionResult, triggerCheckInstantResult]);


  if (isLoadingCheckResult) return <Loading />;

  const redirectToPage = () => {
    if (examType == "free-practice") {
      window.location.href = frontendUrl + `/practice-exam-history/exam/${uprId}`;
    } else {
      window.location.href = frontendUrl + `/practice-exam-history/section/${uprId}?section=${productType}`;
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
      <div class="flex w-full max-w-6xl mx-auto p-12 text-center relative overflow-hidden shadow-2xl bg-[var(--background-color)] border rounded-2xl">
        <div className="w-1/2 pr-6">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-2 bg-[#FC532B]"></div>
          <div className="absolute top-4 right-4 w-16 h-16 bg-[#FC532B] rounded-full opacity-20"></div>
          <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#FC532B] rounded-full opacity-15"></div>

          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-[#FC532B] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <FaCheckCircle className="text-white text-4xl" />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl font-bold text-var(--text-color) mb-4">Practice Exam Completed!</h2>
            <p className="text-lg text-var(--text-color) opacity-80 mb-8 leading-relaxed">
              Great job! You've successfully completed your practice exam.
              Click below to view your detailed results and performance analysis.
            </p>

            {/* Action Button */}
            <button
              onClick={redirectToPage}
              className="bg-[#FC532B] hover:bg-[#e04a26] text-white font-bold px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center mx-auto text-lg group"
            >
              <FaChartBar className="mr-3 group-hover:rotate-12 transition-transform" />
              View Results
              <FaArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" />
            </button>

            {/* Additional Info */}
            <div className="mt-8 p-4 bg-var(--background-color) border border-var(--border-color) rounded-lg">
              <p className="text-sm text-var(--text-color) opacity-70">
                Your results will show detailed breakdowns of your performance across all sections.
              </p>
            </div>
          </div>
        </div>

        <div className="w-1/2 pr-6">           {/* Feedback Section */}
          <div className="mt-8">
            <h4 className="text-xl font-semibold text-var(--text-color) mb-4">Share Your Experience</h4>
            <div className="bg-var(--background-color) border border-var(--border-color) rounded-xl p-6">
              <Feedback />
            </div>
          </div>
        </div>
      </div>

    </div >
  );
};

export default PracticeExamFinished;
